import { isLiveChatResponse } from '@alme/api-ts/Utils';
import merge from 'deepmerge';
import sendAutoLaunchMessage from './initialize/sendAutoLaunchMessage';
import getConfiguration from './initialize/getConfiguration';
import ivaAvailability from './initialize/ivaAvailability';
import loadAlmeHistory from './initialize/loadAlmeHistory';
import { getLastResponseExtensionData } from './initializeAppEvents';
import { setEchatSessionInfoCalled } from './SessionMessages';
import { updateOperatorNameInBeginLiveChatResponseHistory } from '../LiveChat/AlmeLiveChatResponse/UpdateChatResponses';
export default async function initializeAlmeApp(almeState, setAlmeState, appConfig, setAppConfig, almeApiUtils, propsIsOpen) {
    let sessionMessages = almeState.sessionMessages;
    if (appConfig.main.platform === "RC" && appConfig.main.isLoggedIn) {
        const sessionId = appConfig.main.clientSessionId;
        sessionMessages = setEchatSessionInfoCalled(almeState, sessionId);
    }
    const configSettings = await getConfiguration(almeApiUtils);
    const config = merge.all([appConfig, configSettings]);
    config.allowedOrigins = configSettings["PostMessageAllowedOrgins"];
    if (config.ClientSessionTimeout) {
        config.sessionTimeoutInMs = (+config.ClientSessionTimeout) * 60000;
    }
    setAppConfig(config);
    ivaAvailability(config);
    const curHistory = await loadAlmeHistory(almeApiUtils);
    updateOperatorNameInBeginLiveChatResponseHistory(curHistory);
    let isLiveChatConnected = false, lastEntryId;
    if (curHistory.length) {
        const lastHistoryItem = curHistory[curHistory.length - 1];
        isLiveChatConnected = isLiveChatResponse(lastHistoryItem);
        lastEntryId = lastHistoryItem.extensionData.entryId;
    }
    const hasPrevConversation = curHistory.length >= 1;
    sendAutoLaunchMessage(almeState);
    const extensionData = getLastResponseExtensionData(curHistory);
    almeState.history.push(...curHistory);
    setAlmeState(Object.assign(Object.assign({}, almeState), { historyLoaded: true, hasPreviousConversation: hasPrevConversation, lastEntryId: lastEntryId, chatId: extensionData === null || extensionData === void 0 ? void 0 : extensionData.chatId, launchQuestion: undefined, isLiveChatConnected, 
        // No active session, do not open IVA
        isOpen: (almeState.isOpen && hasPrevConversation) || propsIsOpen, 
        // No active session, set session expired false
        sessionExpired: almeState.sessionExpired && hasPrevConversation, 
        // No active session, reset last activity time
        lastActivityTime: hasPrevConversation ? almeState.lastActivityTime : undefined, sessionMessages }));
}
